import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ContestHandoverDispute } from './contest-handover-disputes.model';

export interface GenerateContestHandoverDisputeOptions {
  readonly handoverId: number;
  readonly description?: string;
}

export function generateContestHandoverDisputeObject({
  handoverId,
  description = 'Dispute description',
}: GenerateContestHandoverDisputeOptions): ContestHandoverDispute {
  return {
    id: generateId(),
    handoverId,
    description,
  };
}
